import { createContext, FC, ReactNode, useContext, useState } from "react";
import { useLocalStorage } from "../../utils/useLocalStorage";
import { DEFAULT_ENTITY_TYPE_FILTER_VALUE } from "../../components/filters/CompanyType/constants";

const LOCALIZE_INSTALL_SETTING_LOCAL_STORAGE_KEY = "localizeInstalls";

const useProductCatalogContextValue = () => {
  const [entityTypeFilterValue, setEntityTypeFilterValue] = useState(
    DEFAULT_ENTITY_TYPE_FILTER_VALUE
  );

  const [localizeInstalls] = useLocalStorage<boolean>(
    LOCALIZE_INSTALL_SETTING_LOCAL_STORAGE_KEY,
    true
  );

  return {
    entityTypeFilterValue,
    setEntityTypeFilterValue,
    localizeInstalls,
  };
};

const ProductCatalogContext = createContext<
  ReturnType<typeof useProductCatalogContextValue> | undefined
>(undefined);

interface ProductCatalogProviderProps {
  children: ReactNode;
}

export const ProductCatalogProvider: FC<ProductCatalogProviderProps> = ({
  children,
}) => {
  const value = useProductCatalogContextValue();

  return (
    <ProductCatalogContext.Provider value={value}>
      {children}
    </ProductCatalogContext.Provider>
  );
};

export const useProductCatalogContext = () => {
  const context = useContext(ProductCatalogContext);

  if (!context) {
    throw new Error(
      "useProductCatalogContext must be within the ProductCatalogProvider"
    );
  }

  return context;
};
